import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormFeedback,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";

// Backend
import { getClientFullList, getClientPayment } from "connection/backend";

// actions
import { ticketCreate, consignmentCreate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const TicketCreate = (props) => {
  const [alert, setAlert] = useState(true);
  const [alert1, setAlert1] = useState(true);
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [clients, setClients] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState({});
  const [payment, setPayment] = useState(false);
  const [formData, setFormData] = useState({
    client: "",
    animal_number: "",
  });
  const { client, animal_number } = formData;
  const [value, setValue] = useState("");
  const [formData1, setFormData1] = useState({
    payment_method: "efectivo",
    bank: "banco_1",
  });
  const { payment_method, bank } = formData1;

  useEffect(() => {
    getClientData();
  }, []);

  useEffect(() => {
    if (client) {
      setPayment(true);
    }
  }, [paymentStatus]);

  const history = useHistory();
  const redirect = () => {
    history.push("/tickets");
  };

  const toggle = () => setModal(!modal);
  const toggle1 = () => setModal1(!modal1);
  const toggle2 = () => setModal2(!modal2);

  const getClientData = async () => {
    const response = await getClientFullList();
    const data = response.data;
    setClients(data);
  };

  const getPaymentStatus = async (id) => {
    if (id) {
      const response = await getClientPayment(id);
      const data = response.data;
      setPaymentStatus(data);
    }
  };

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const dispatch = useDispatch();

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(
      ticketCreate({
        client: formData.client,
        animal_number: parseInt(formData.animal_number),
      })
    );
  };

  const onChange1 = (e) => {
    if (e.target.name === "value") {
      const valor = e.target.value;
      const formattedValue = valor
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      setValue(formattedValue);
    } else {
      setFormData1({ ...formData1, [e.target.name]: e.target.value });
    }
  };

  const onSubmit1 = (e) => {
    e.preventDefault();
    toggle();
    dispatch(
      consignmentCreate({
        client: client,
        payment_method: formData1.payment_method,
        value: parseInt(value.replace(/\./g, "")),
        ticket: props.ticketCreated.code,
        bank: payment_method !== "efectivo" ? bank : "no_aplica",
      })
    );
  };

  const onSubmit2 = (e) => {
    e.preventDefault();
    toggle2();
    dispatch(
      consignmentCreate({
        client: client,
        payment_method: formData1.payment_method,
        value: parseInt(value.replace(/\./g, "")),
        bank: payment_method !== "efectivo" ? bank : "no_aplica",
      })
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Tickets </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Tickets"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.ticketCreated.code ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  show={alert}
                  onConfirm={() => {
                    setAlert(false);
                    toggle();
                  }}
                >
                  La entrada se registró correctamente.
                </SweetAlert>
              ) : null}
              {props.consignmentCreated.id ||
              props.consignmentCreated.detail ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  show={alert1}
                  onConfirm={() => {
                    setAlert1(false);
                    toggle1();
                  }}
                >
                  El abono se registró correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Nuevo ticket</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={7}>
                        <p>Registrar entrada de ganado</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mb-4">
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bxs-contact bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="select"
                              className="form-control"
                              placeholder="Cliente"
                              name="client"
                              id="client"
                              value={client}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.client || props.error.detail
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            >
                              <option defaultValue value="">
                                -----
                              </option>
                              {clients.map((client, idx) => (
                                <option
                                  key={idx}
                                  value={client.code}
                                >{`${client.code} - ${client.full_name}`}</option>
                              ))}
                            </Input>
                            <FormFeedback tooltip>
                              {props.error.client || props.error.detail}
                            </FormFeedback>
                            <Label for="client">Cliente</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={2}>
                        <Row>
                          <Col lg={3} className="pt-3">
                            <Link to="/clients/create">
                              <span
                                className="bx bx-plus-circle bx-sm"
                                id="client_add"
                              ></span>
                              <UncontrolledTooltip
                                placement="top"
                                target="client_add"
                              >
                                Agregar nuevo cliente
                              </UncontrolledTooltip>
                            </Link>
                          </Col>
                          <Col lg={9} className="pt-2">
                            <Button
                              color="secondary"
                              type="button"
                              onClick={() => getPaymentStatus(client)}
                            >
                              Consultar
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {payment ? (
                      <Row className="justify-content-md-center">
                        <Col lg={7} style={{ alignContent: "center" }}>
                          <p className="card-title">
                            <a
                              className="bx bx-edit fa-lg align-middle"
                              style={
                                paymentStatus.balance < 0
                                  ? { color: "red" }
                                  : { color: "green" }
                              }
                              onClick={() => toggle2()}
                            />{" "}
                            El cliente {paymentStatus.code} tiene un saldo de{" "}
                            <b>
                              $ {paymentStatus.balance.toLocaleString("es-CO")}
                            </b>{" "}
                            y tiene <b>{paymentStatus.checks_number}</b> cheques
                            pendientes por aprobación.
                          </p>
                        </Col>
                      </Row>
                    ) : null}
                    <Row className="justify-content-md-center me-5">
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-spreadsheet bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="number"
                              className="form-control"
                              placeholder="Número de bovinos"
                              name="animal_number"
                              id="animal_number"
                              value={animal_number}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.animal_number
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.animal_number}
                            </FormFeedback>
                            <Label for="animal_number">Número de bovinos</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-0">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/tickets">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Registrar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered={true}
        backdrop="static"
        size="lg"
      >
        <ModalHeader>Resumen de entrada</ModalHeader>
        <ModalBody>
          {props.ticketCreated.code ? (
            <>
              <Row className="mb-3">
                <Col lg={10}>
                  <b className="font-size-14">Fecha de ingreso: </b>
                  {props.ticketCreated.created_date}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={4}>
                  <b className="font-size-14">Código de cliente: </b>
                  {props.ticketCreated.client}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Nombre: </b>
                  {props.ticketCreated.client_name}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Código de ticket: </b>
                  {props.ticketCreated.code}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={4}>
                  <b className="font-size-14">Número de bovinos: </b>
                  {props.ticketCreated.animal_number}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Total: </b>
                  $ {props.ticketCreated.total.toLocaleString("es-CO")}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Saldo: </b>
                  $ 
                  {props.ticketCreated.client_balance.toLocaleString("es-CO")}
                </Col>
              </Row>
              <Form onSubmit={onSubmit1}>
                <Row className="mb-3">
                  <Col lg={4}>
                    <b className="font-size-14">Medio de pago: </b>
                    <select
                      className="form-select"
                      id="payment_method"
                      name="payment_method"
                      value={payment_method}
                      onChange={onChange1}
                    >
                      <option value="efectivo">Efectivo</option>
                      <option value="consignacion">Consignación</option>
                      <option value="cheque">Cheque</option>
                    </select>
                  </Col>
                  {payment_method !== "efectivo" ? (
                    <Col lg={4}>
                      <b className="font-size-14">Banco: </b>
                      <select
                        className="form-select"
                        id="bank"
                        name="bank"
                        value={bank}
                        onChange={onChange1}
                      >
                        <option value="banco_1">Banco de Bogotá</option>
                        <option value="banco_2">Bancolombia</option>
                      </select>
                    </Col>
                  ) : null}
                  <Col lg={4}>
                    <b className="font-size-14">Abono: </b>
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Ingrese el valor..."
                      name="value"
                      id="value"
                      value={value}
                      onChange={onChange1}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Button
                      color="primary"
                      className="btn col-12"
                      type="submit"
                    >
                      Registrar abono
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => redirect()}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={modal1}
        toggle={toggle1}
        centered={true}
        backdrop="static"
        size="lg"
      >
        <ModalHeader>Resumen de abono</ModalHeader>
        <ModalBody>
          {props.consignmentCreated.id ? (
            <>
              <Row className="mb-3">
                <Col lg={10}>
                  <b className="font-size-14">Fecha de ingreso: </b>
                  {props.consignmentCreated.created_date}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={4}>
                  <b className="font-size-14">Código de cliente: </b>
                  {props.consignmentCreated.client}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Nombre: </b>
                  {props.consignmentCreated.full_name}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Código de consignación: </b>
                  {props.consignmentCreated.id}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg={4}>
                  <b className="font-size-14">Método de pago: </b>
                  {`${props.consignmentCreated.payment_method
                    .charAt(0)
                    .toUpperCase()}${props.consignmentCreated.payment_method.slice(
                    1
                  )}`}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Valor: </b>
                  $ {props.consignmentCreated.value.toLocaleString("es-CO")}
                </Col>
                <Col lg={4}>
                  <b className="font-size-14">Saldo: </b>
                  $ 
                  {props.consignmentCreated.balance.toLocaleString("es-CO")}
                </Col>
              </Row>
            </>
          ) : (
            <p className="card-title">
              El cheque ha sido registrado y está pendiente de aprobación.
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => redirect()}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={modal2}
        toggle={toggle2}
        centered={true}
        backdrop="static"
        size="lg"
      >
        <ModalHeader>Abono</ModalHeader>
        <ModalBody>
          {paymentStatus.code ? (
            <>
              <Row className="justify-content-md-center mb-3">
                <Col lg={5}>
                  <b className="font-size-14">Código de cliente: </b>
                  {paymentStatus.code}
                </Col>
                <Col lg={5}>
                  <b className="font-size-14">Saldo: </b>${" "}
                  {paymentStatus.balance.toLocaleString("es-CO")}
                </Col>
              </Row>
              <Form onSubmit={onSubmit2}>
                <Row className="justify-content-md-center mb-3">
                  <Col lg={5}>
                    <b className="font-size-14">Medio de pago: </b>
                    <select
                      className="form-select"
                      id="payment_method"
                      name="payment_method"
                      value={payment_method}
                      onChange={onChange1}
                    >
                      <option value="efectivo">Efectivo</option>
                      <option value="consignacion">Consignación</option>
                      <option value="cheque">Cheque</option>
                    </select>
                  </Col>
                  {payment_method !== "efectivo" ? (
                    <Col lg={5}>
                      <b className="font-size-14">Medio de pago: </b>
                      <select
                        className="form-select"
                        id="bank"
                        name="bank"
                        value={bank}
                        onChange={onChange1}
                      >
                        <option value="banco_1">Banco de Bogotá</option>
                        <option value="banco_2">Bancolombia</option>
                      </select>
                    </Col>
                  ) : null}
                  <Col lg={5}>
                    <b className="font-size-14">Abono: </b>
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Ingrese el valor..."
                      name="value"
                      id="value"
                      value={value}
                      onChange={onChange1}
                      required
                    />
                  </Col>
                </Row>
                <Row className="justify-content-md-center">
                  <Col lg={10}>
                    <Button
                      color="primary"
                      className="btn col-12"
                      type="submit"
                    >
                      Registrar abono
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => toggle2()}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, ticketCreated, consignmentCreated } = state.Billing;
  return { error, loading, ticketCreated, consignmentCreated };
};

export default withRouter(connect(mapStateToProps)(TicketCreate));
